export default function PHP_readdir() {
  return (
    <div>
      <h1>PHP_readdir</h1>
    </div>
  );
}
